export default "__VITE_ASSET__AI_nLui9__"